var _ = "p273__ballon-7423_fc90d7d40__1veg4yd0";
export {
  _ as ballonStyle
};
//# sourceMappingURL=ballon.mjs.map
